@if (!unCommerceApp) {
  <button class="add-to-cart btn-style leaf-btn btn w-100 h-100 py-0 d-flex justify-content-center align-items-center" (click)="add()" spinEl [spinning]="processing" [disabled]="disabled">
    <i class="fa fa-shopping-cart"></i>
    <span translate>{{addToCartText}}</span>
  </button>
}
@if (!unCommerceApp && quickBuy) {
  <button class="mr-0 mr-lg-5 mt-3 mt-lg-0 pr-3 quick-add-to-cart app-btn-add-to-cart leaf-btn btn" (click)="type='quickBuy'; add()" spinEl [spinning]="processing" [disabled]="disabled">
    <i class="fa fa-shopping-cart"></i>
    <span translate>Quick Buy</span>
  </button>
}
